const defaultAppComponentsData = require("../../../src/vue/appComponents");

const tunisiaAppComponents = {
    PromotionsItems: () => import('./components/pages/parts/target/PromotionsItems.vue'),
    PlatformsItems: () => import('./components/pages/parts/target/PlatformsItems.vue'),
    PromotionsPopups: () => import('./components/popups/PromotionsPopups.vue'),
    CatalogBarWithProviderFilter: () => import('./components/CatalogBarWithProviderFilter.vue'),
    SearchCatalogBar: () => import('./components/layout/SearchCatalogBar.vue'),
};

const tunisiaEntryPointComponents = {
    TheFooter: './themes/tunisia/modules/components/layout/TheFooter.vue',
};

let appComponents = Object.assign(defaultAppComponentsData.appComponents, tunisiaAppComponents);

let entryPointComponents = Object.assign(defaultAppComponentsData.entryPointComponents, tunisiaEntryPointComponents);

module.exports = {
    appComponents,
    entryPointComponents,
};